
import {Navigate} from "react-router-dom";
import {useContext} from "react";
import {SignInContext} from "../context/SignInContext";
import {ProjectRoles} from "../context/AppContext"; // or however you get the logged-in user

export const ProtectedRoute = ({ element, allowedRoles = [], project }) => {
  const {currentUser} = useContext(SignInContext); // You can replace this with your auth context, Jotai, etc.

  const userRole = currentUser?.roles?.includes("admin") ? ProjectRoles.ADMIN : project?.members?.find(m => m?.username === currentUser?.username)?.role;

  if (!userRole || !allowedRoles.includes(userRole)) {
    return <Navigate to={`/project/${project?.id}`} replace />;
  }

  return element;
};
